<fa-icon *ngIf="useFontAwesome; else useFeather" [icon]="icon" [size]="size"></fa-icon>
<ng-template #useFeather>
  <ng-container [ngSwitch]="icon">
    <fa-icon *ngSwitchCase="'x'" [icon]="defaultIcons.faTimes" [size]="size"></fa-icon>
    <fa-icon *ngSwitchCase="'upload-cloud'" [icon]="defaultIcons.faFileUpload" [size]="size"></fa-icon>
    <span *ngSwitchDefault>ICON {{ icon }}</span>
  </ng-container>
</ng-template>
